import script from "./flex.vue?vue&type=script&lang=ts&setup=true"
export * from "./flex.vue?vue&type=script&lang=ts&setup=true"

import "./flex.vue?vue&type=style&index=0&id=13e8ea4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13e8ea4a"]])

export default __exports__